import { Injectable } from '@angular/core';
import { Params } from '@angular/router/src/shared';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment'
import { Router } from '@angular/router';
import {JwtHelper} from "angular2-jwt/angular2-jwt";
import {UserProfile} from "../../shared/models/user-profile";
import {AuthGuardService} from "../../shared/services/auth-guard.service";
import { Observable } from 'rxjs/Rx';

@Injectable()
export class BypassService {

  constructor(
    private http: HttpClient,
    private router: Router,
    private authGuardService: AuthGuardService
  ) { }

  bypassWithSCPData(params: Params): Observable<any>{

    this.authGuardService.clearToken();

    let grantType = "password";
    let clientCredentials = "trusted-app:secret";

    let details = `A=${params["A"]}&B=${params["B"]}&L=${params["L"]}`;

    let body = `grant_type=${grantType}&details=${encodeURIComponent(details)}`;

    let options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .set('Authorization', `Basic ${btoa(clientCredentials)}`)
    };

    return this.http.post(environment.backUrl + 'oauth/token', body, options);
  }

  loadUserProfileInformation(): Observable<any>{
    return this.http.get(environment.backUrl + 'api/userProfile/');
  }
}



// WEBPACK FOOTER //
// /app/src/app/modules/bypass/bypass.service.ts